import React, { ReactElement, FC } from 'react';

import { Logo } from '@infologistics/frontend-libraries';
import { useAppSelector } from '@app/hooks/redux';
import { Path } from '@app/const/paths';
import { DEFAULT_GD_LOGO_SRC, Direction } from '@app/const/consts';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import styles from './styles.module.css';

const LogoWrapper: FC = (): ReactElement => {
  const {
    profile: { boxOguid },
  } = useAppSelector((state) => state.user);
  const { currentBoxOguid } = useAppSelector((state) => state.envelopes);
  const { boxes } = useAppSelector((state) => state.boxes);

  const linkPath = Path.ENVELOPES_BOX_OGUID.replace(
    ':boxOguid',
    currentBoxOguid || boxOguid
  ).replace(':directionOrFolder', Direction.INCOMING);

  const currentLogo =
    currentBoxOguid && boxes.find((val) => val.oguid === currentBoxOguid)?.logo;
  const logoOrgSrc = currentLogo || DEFAULT_GD_LOGO_SRC;

  return (
    <div
      className={cn(
        styles.logo_wrapper,
        currentLogo && styles.logo_custom_wrapper
      )}
    >
      <Link to={linkPath}>
        <Logo src={logoOrgSrc} alt='greenDocs' />
      </Link>
    </div>
  );
};

export default LogoWrapper;
